'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubNavigationBarLink = exports.SubNavigationBarTitle = exports.SubNavigationBar = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _Pane = require('./Pane');

var _Pane2 = _interopRequireDefault(_Pane);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

var _Link = require('./Link');

var _Link2 = _interopRequireDefault(_Link);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var minorScale = _theme2.default.minorScale,
    majorScale = _theme2.default.majorScale;


var SubNavigationBarLink = function SubNavigationBarLink(props) {
  return _react2.default.createElement(_Link2.default, _extends({}, (0, _glamor.css)({
    '&:active, &:hover, &.active': {
      boxShadow: '0 1px ' + _theme2.default.rawColors.blue500
    }
  }), props));
};

SubNavigationBarLink.defaultProps = {
  secondary: true,
  textStyle: 'body1',
  paddingBottom: majorScale(2),
  marginX: minorScale(3)
};

var SubNavigationBarTitle = function SubNavigationBarTitle(props) {
  return _react2.default.createElement(_Text2.default, props);
};

SubNavigationBarTitle.defaultProps = {
  is: 'h2',
  textStyle: 'display4'
};

var SubNavigationBarPane = function SubNavigationBarPane(props) {
  return _react2.default.createElement(_Pane2.default, props);
};

SubNavigationBarPane.defaultProps = {
  display: 'flex',
  white: true,
  borderBottom: true
};

var SubNavigationBar = function SubNavigationBar(_ref) {
  var left = _ref.left,
      right = _ref.right,
      children = _ref.children;

  var leftChild = void 0;
  if (typeof left === 'string') {
    leftChild = _react2.default.createElement(
      SubNavigationBarTitle,
      null,
      left
    );
  } else {
    leftChild = left;
  }

  return _react2.default.createElement(
    SubNavigationBarPane,
    null,
    _react2.default.createElement(
      _Pane2.default,
      { width: '25%', padding: majorScale(2), flex: '0 0 auto' },
      leftChild
    ),
    _react2.default.createElement(
      _Pane2.default,
      { flexAuto: true, textAlign: 'center', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' },
      children
    ),
    _react2.default.createElement(
      _Pane2.default,
      { width: '25%', textAlign: 'right', flex: '0 0 auto' },
      right
    )
  );
};

SubNavigationBar.propTypes = _extends({}, _Box2.default.propTypes, {
  left: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  right: _propTypes2.default.node
});

SubNavigationBar.defaultProps = {
  theme: _theme2.default
};

exports.SubNavigationBar = SubNavigationBar;
exports.SubNavigationBarTitle = SubNavigationBarTitle;
exports.SubNavigationBarLink = SubNavigationBarLink;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/SubNavigationBar.js
// module id = 1135
// module chunks = 0